import type { SharedColumnDto } from '@pams/shared';
import { PREVIEW_COPY } from './copy';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C5c §2] WHAT ONE CARD SAYS ABOUT A COLUMN ASKED FOR ONCE ACROSS THE ORDER — the preview modal
 *  and the record view both render this, so the two cannot word it differently.
 *
 *  A COVERED card carries no line for the column, so its force table cannot show it; this line is
 *  the only place the card says the column exists and where its people are named. The ANCHOR
 *  carries the line, and this says its number is the whole order's.
 *
 *  ⚠️ `DP{n}` IS THE ANCHOR'S `displayOrder + 1` — the ordinal every reader of the order prints —
 *  resolved by the host from the record, never from an array index.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const SharedColumnLines = ({
  shared,
  dutyPointId,
  ordinalOf,
  testIdPrefix,
}: {
  shared: readonly SharedColumnDto[];
  dutyPointId: string;
  ordinalOf: (dutyPointId: string) => number | undefined;
  testIdPrefix: string;
}) => {
  const covered = shared.filter((entry) => entry.anchorDutyPointId !== dutyPointId);
  const anchored = shared.filter((entry) => entry.anchorDutyPointId === dutyPointId);
  if (covered.length === 0 && anchored.length === 0) return null;
  return (
    <ul className="flex flex-col gap-0.5 text-xs text-muted-foreground" data-testid={`${testIdPrefix}-${dutyPointId}`}>
      {covered.map((entry) => (
        <li key={entry.lineKey}>
          {PREVIEW_COPY.sharedFrom(entry.label, `DP${String(ordinalOf(entry.anchorDutyPointId) ?? '?')}`)}
        </li>
      ))}
      {anchored.map((entry) => (
        <li key={entry.lineKey}>{PREVIEW_COPY.coversEvery(entry.label)}</li>
      ))}
    </ul>
  );
};
